/**
 * Mobile filters drawer: drill-down navigation between the group index (Category, Goal, ...)
 * and a single group's detail panel (its own back arrow + checkbox/price-range list).
 */
class FacetGroupNav extends HTMLElement {
  connectedCallback() {
    // The footer rows live in the drawer's `slot="footer"`, a sibling (not a descendant) of
    // this element, so they're searched for from the shared `<facet-drawer>` ancestor instead.
    const drawerRoot = this.closest('facet-drawer') || this;

    this.indexEl = this.querySelector('[data-facet-index]');
    this.indexFooterEl = drawerRoot.querySelector('[data-facet-index-footer]');
    this.detailFooterEl = drawerRoot.querySelector('[data-facet-detail-footer]');

    this.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-open-panel]');
      if (openTrigger) {
        this._openPanel(openTrigger.getAttribute('data-open-panel'));
        return;
      }

      if (event.target.closest('[data-close-panel]')) {
        this._closeAllPanels();
      }
    });

    // Reset back to the group index whenever the whole drawer is dismissed, so it doesn't
    // reopen stuck on the last viewed group's detail panel.
    drawerRoot.addEventListener('dialog:after-hide', () => this._closeAllPanels());
  }

  _openPanel(id) {
    this.querySelectorAll('[data-facet-panel]').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-facet-panel') !== id;
    });

    if (this.indexEl) this.indexEl.hidden = true;
    if (this.indexFooterEl) this.indexFooterEl.hidden = true;
    if (this.detailFooterEl) this.detailFooterEl.hidden = false;

    this.setAttribute('data-active-panel', id);
  }

  _closeAllPanels() {
    this.querySelectorAll('[data-facet-panel]').forEach((panel) => {
      panel.hidden = true;
    });

    if (this.indexEl) this.indexEl.hidden = false;
    if (this.indexFooterEl) this.indexFooterEl.hidden = false;
    if (this.detailFooterEl) this.detailFooterEl.hidden = true;

    this.removeAttribute('data-active-panel');
  }
}

if (!window.customElements.get('facet-group-nav')) {
  window.customElements.define('facet-group-nav', FacetGroupNav);
}

/**
 * Sort-by bottom sheet: picking an option should apply it (already handled by the form's
 * own `update-on-change` submit) and close the sheet immediately, since sort is a single-select
 * action, not something you refine before confirming like the filters drawer.
 */
document.addEventListener('change', (event) => {
  const form = event.target.closest('[data-sort-drawer-form]');
  if (!form) return;

  const drawer = form.closest('facet-drawer');
  if (drawer) drawer.hide();
});

